import React from 'react'
import { Row, Col } from 'react-bootstrap'
import SentimentAnalysisChart from '../components/reports/SentimentAnalysisChart'
import SentimentAnalysisPieChart from '../components/reports/SentimentAnalysisPieChart'
import ClassificationReport from '../components/reports/ClassificationReport'
import AudienceProfileReport from '../components/reports/AudienceProfileReport'
import ExtractionReport from '../components/reports/ExtractionReport'
import SummarisationReport from '../components/reports/SummarisationReport'
import Card from '../components/common/Card'
import { AiReportsIcon } from '../components/icons'

const Reports = () => {
    return (
        <Card className="page-card">
            <Card.Header className="page-card-header">
                <div className="header-title">
                    <h5 className="title mb-0 text-white d-flex align-items-center">
                        <i className="icon text-gray-200 me-2">
                            <AiReportsIcon size={24} />
                        </i>
                        AI Reports
                    </h5>
                </div>
            </Card.Header>
            <Card.Body className="page-card-body">
                <Row>
                    <SentimentAnalysisChart name={'Sentiment Analysis'} />
                    <SentimentAnalysisPieChart name={'Generative AI Sentiment'} />
                </Row>
                <Row>
                    <Col md={12}>
                        <AudienceProfileReport />
                    </Col>
                </Row>
                <Row>
                    <Col md={12} lg={6}>
                        <ClassificationReport />
                    </Col>
                    <Col md={12} lg={6}>
                        <ExtractionReport />
                    </Col>
                    <Col md={12}>
                        <SummarisationReport />
                    </Col>
                </Row>
            </Card.Body>
        </Card>
    )
}

export default Reports
